import React from "react";
import { QueueHistoryTableRow, useQueueHistory } from "pages/dashboard/queue/tabs/history";
import { Table } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

export const QueueHistoryTable = props => {

    const { entries } = useQueueHistory();

    return (
        <Table className="m-0" borderless striped>
            <thead>
                <tr>
                    <th>
                        <FormattedMessage
                            defaultMessage="Application User"
                            id="label.application_user"
                        />
                    </th>
                    <th>
                        <FormattedMessage
                            defaultMessage="Product"
                            id="label.product"
                        />
                    </th>
                    <th>
                        <FormattedMessage
                            defaultMessage="Locale"
                            id="label.locale"
                        />
                    </th>
                    <th>
                        <FormattedMessage
                            defaultMessage="Duration"
                            id="label.duration"
                        />
                    </th>
                    <th>
                        <FormattedMessage
                            defaultMessage="Start Time"
                            id="label.start_time"
                        />
                    </th>
                    <th>
                        <FormattedMessage
                            defaultMessage="Last State"
                            id="label.last_state"
                        />
                    </th>
                </tr>
            </thead>
            <tbody>
                {entries?.length ?
                (
                    <>
                        {entries.map((entry, key) => (
                            <QueueHistoryTableRow entry={entry} key={key} idx={key} />
                        ))}
                    </>
                )
                :
                (
                    <tr>
                        <td colSpan={5} className="text-center">
                            <span>
                                <FormattedMessage
                                    defaultMessage="No queue history records"
                                    id="label.no_queue_history_records"
                                        />
                            </span>
                        </td>
                    </tr>
                )
            }
            </tbody>
        </Table>
    );

};